import React from "react";

export const SectionHeadingTitle = ({ prop }) => {
    return <h1 className="section-heading__title">{prop}</h1>;
}
